import React from 'react';
import { Share2, Search, Filter } from 'lucide-react';
import { cn } from '@/lib/utils';
import { ActionButton, ActionButtonType } from './ActionButtons';

interface UtilityRowProps {
  onFilterClick: () => void;
  onButtonClick: (button: ActionButtonType) => void;
  activeFilter: boolean;
  activeButton: ActionButtonType | null;
  className?: string;
}

export function UtilityRow({
  onFilterClick,
  onButtonClick,
  activeFilter,
  activeButton,
  className
}: UtilityRowProps) {
  return (
    <div className={cn(
      "flex items-center justify-between py-3 px-0",
      className
    )}>
      <button
        onClick={onFilterClick}
        aria-label="Filter trades"
        className={cn(
          "flex items-center rounded-md transition-colors px-4 py-2 border-2",
          activeFilter
            ? "bg-purple-100 text-purple-900 border-purple-300 font-medium"
            : "bg-white hover:bg-purple-50 text-purple-800 border-purple-200 font-medium"
        )}
      >
        <Filter className="h-4 w-4 mr-2" />
        <span className="text-sm font-medium">Filter</span>
      </button>

      <div className="flex gap-3">
        <button
          onClick={() => onButtonClick('share')}
          aria-label="Share your list"
          className={cn(
            "flex items-center justify-center rounded-md transition-colors w-10 h-10 border-2",
            activeButton === 'share'
              ? "bg-purple-100 text-purple-900 border-purple-300"
              : "bg-white hover:bg-purple-50 text-purple-800 border-purple-200"
          )}
        >
          <Share2 className="h-5 w-5" />
        </button>
        <button
          onClick={() => onButtonClick('find')}
          aria-label="Find tradespeople"
          className={cn(
            "flex items-center justify-center rounded-md transition-colors w-10 h-10 border-2",
            activeButton === 'find'
              ? "bg-purple-100 text-purple-900 border-purple-300"
              : "bg-white hover:bg-purple-50 text-purple-800 border-purple-200"
          )}
        >
          <Search className="h-5 w-5" />
        </button>
      </div>
    </div>
  );
}
